import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsSessionValid } from '../store/slices/authSlice';

/**
 * Layout route for everything that needs a session. Renders its children
 * through `Outlet`, or sends a signed-out visitor to sign-in.
 *
 * The attempted path travels in `location.state.from` so SignIn can return the
 * user there instead of dumping them on the dashboard — a deep link mailed to a
 * trader survives the detour through sign-in.
 */
export default function PrivateRoute() {
  const isSignedIn = useSelector(selectIsSessionValid);
  const location = useLocation();

  if (!isSignedIn) {
    return (
      <Navigate
        to="/sign-in"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <Outlet />;
}
